import { useContext } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useFormContext } from 'react-hook-form';
import { userExistsApi } from '../../../gql/recognizeCustomerForm.gql';
import isValidEmail from '../../../tools/validations/isValidEmail';
import {
  getPurxCheckoutConfig,
} from '../../../tools/utils';
import useLog from '../../useLog/useLog';
import useSwitchesFromContext from '../../../hooks/useSwitchesFromContext';
import CheckoutPageContext from '../../../context/CheckoutPageContext';

const useUserExists = () => {
  const { getValues } = useFormContext();
  const {
    setUserExists,
    userExists,
  } = useContext(CheckoutPageContext);
  const logger = useLog('checkout.userExists');
  const [checkUserExists] = useLazyQuery(userExistsApi);
  const { hasSteppedCheckout } = getPurxCheckoutConfig();
  const { getSwitchValue } = useSwitchesFromContext();
  const orderContactRecognizeCustomer = getSwitchValue('orderContactRecognizeCustomer');
  const hasOrderContactSignin = hasSteppedCheckout && orderContactRecognizeCustomer;

  const triggerUserExists = async () => {
    const formValues = getValues();
    const email = formValues?.email;
    // TODO: clean up the switches once the feature is stable
    if (hasOrderContactSignin) {
      if (userExists) {
        return true;
      }

      if (email && isValidEmail(email)) {
        return checkUserExists({
          variables: { email },
        }).then((response) => {
          setUserExists(response.data?.userExists || false);
          return !response.data?.userExists;
        }).catch((error) => {
          logger.error('checkUserExists ERROR', error);
          return true;
        });
      }
    }
    return true;
  };

  return {
    triggerUserExists,
  };
};

export default useUserExists;
